export default {
  toggle: false,
  whatsappNumber: "",
  whatsappToggle:false
};
